module.exports = "/images/dmlczlogo.png?3bfbfe5357dcf54c934b69234960d548";